import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { BaseIcon, CloseIcon, OpenIcon } from "@/components/icons";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'MobileMenuToggle',
  emits: ["closeMenu"],
  setup(__props, { emit: __emit }) {

  const emit = __emit;
  const auctionStore = useAuctionStore();

  const isOpen = computed(() => {
    return auctionStore.isMobileMenuOpen;
  });

  const toggleMenu = () => {
    auctionStore.$patch({
      isMobileMenuOpen: !isOpen.value
    });
    document.body.classList.toggle("mobile-menu-open");

    if (!isOpen.value) {
      emit("closeMenu");
    }
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _withModifiers(toggleMenu, ["prevent"]),
    class: "header-menu-open"
  }, [
    (!isOpen.value)
      ? (_openBlock(), _createBlock(_unref(BaseIcon), {
          key: 0,
          class: "icon-open",
          "icon-name": "open",
          width: "29",
          height: "26",
          viewBox: "0 0 29 26"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(OpenIcon))
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_unref(BaseIcon), {
          key: 1,
          class: "icon-close",
          "icon-name": "close",
          width: "26.87",
          height: "26.87",
          viewBox: "0 0 26.87 26.87"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(CloseIcon))
          ]),
          _: 1
        }))
  ]))
}
}

})